// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Yj-z","carouselContainer":"Zj-z","carouselContent":"_j-z"};